import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/build/src/app/portal/(public)/consulta-iptu/components/ConsultaIptu.tsx");
